

// pgw 29-oct-2025
let doprint = false;
// let doprint = true;


export async function loginUser(endpoint, username, password) {
    if (username && password) {
      const loginParams = {
        username64: encodeURIComponent(btoa(username)),
        password64: encodeURIComponent(btoa(password))
      }
      const urlParams = new URLSearchParams(loginParams);
      const requestString = `${endpoint}?${urlParams.toString()}`;
      const response = await fetch(requestString);
      const result = await response.json();

      if (response.status === 200) {
        if (result.status === 'ok') {
          return {
            data: result.user.data
          };
        } else if(result.status === 'error') {
          throw new Error(result.error);
        }
      } else {
        throw new Error('Login error occurred');
      }
    } else {
      if (!username) throw new Error('Please provide a username');
      if (!password) throw new Error('Please provide a password to login')
    }
}


export async function checkSubscription(endpoint, session_id) {


	let urlToCache = "" + endpoint + session_id
	if (doprint) console.log('checkSubscription urlToCache = ', urlToCache)
	const cacheresp = await fetch(urlToCache, { cache: 'no-store' });
	if (doprint) console.log('checkSubscription cacheresp.status = ', cacheresp.status)


	let urlToFetch = `${endpoint}${session_id}`
	if (doprint) console.log('checkSubscription endpoint = ', endpoint)
	if (doprint) console.log('checkSubscription session_id = ', session_id)
	if (doprint) console.log('checkSubscription urlToFetch = ', urlToFetch)

	// pgw 15-oct-2025
    // const response = await fetch(`${endpoint}${session_id}`);
    const response = await fetch(`${endpoint}${session_id}`, { cache: 'no-store' });

    const result = await response.json();

	if (doprint) console.log('checkSubscription response.status = ', response.status)

    if (response.status === 200) {
        return {
          userName: result.user_email,
          subscribed: result.user_role === "1" ? true : false
        };
    } else {
        throw new Error("Error fetching subscription");
    }
    
}